export default __webpack_public_path__ + "static/media/Chevron-up.cf05adc5.svg";